module.exports = __webpack_public_path__ + "static/media/single-family.860e4276.svg";